import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router";
import { CurrencyLabel } from "../../../common/inputs";

import useApi from "../../../../hooks/useApi";
import useIsMounted from "../../../../hooks/useIsMounted";
import EntityContext from "../../../../context/entityContext";
import widgetService from "../../../../services/invTransactions";
import productShortName from "../../../../utils/GetProductShortName";

function DueMonth({ reloadKey = 0 }) {
    const isMounted = useIsMounted();
    const { selectedBusinessType, entityDetails, selProduct } = useContext(EntityContext);
    const [data, setData] = useState([]);

    const paymentsApi = useApi(widgetService.getDueSummary);

    const fetchData = async () => {
        const response = await paymentsApi.request({
            entity_id: entityDetails.a_guid,
            selectedBusinessType,
        });

        const summary = response?.data?.data;

        if (summary && isMounted()) {
            setData([
                {
                    label: "Due in 3 Days",
                    value: summary.due_in_3_days?.due_amt || 0,
                    route: `/client/${productShortName(selProduct)}/sale-invoices?status=open&type=due`,
                },
                {
                    label: "Due in 1 Week",
                    value: summary.due_in_1_week?.due_amt || 0,
                    route: `/client/${productShortName(selProduct)}/sale-invoices?status=open&type=due`,
                },
                {
                    label: "Due in 1 Month",
                    value: summary.due_in_1_month?.due_amt || 0,
                    route: `/client/${productShortName(selProduct)}/sale-invoices?status=open&type=due`,
                },
            ]);
        }
    };

    useEffect(() => {
        if (entityDetails?.a_guid && selectedBusinessType) {
            fetchData();
        }
    }, [selectedBusinessType, entityDetails?.a_guid, reloadKey]);

    return (
        <div className="card ">
            <div className="card-body ">
                {paymentsApi.loading ? (
                    <div className="p-2 text-center">Loading...</div>
                ) : (
                    data.map((item, index) => (
                        <Link
                            key={index}
                            to={item.route}
                            className={`d-flex justify-content-between align-items-center px-3 py-3 text-decoration-none ${
                                index !== data.length - 1 ? "border-bottom" : ""
                            }`}
                            style={{ color: "inherit" }}
                        >
                            <div className="d-flex align-items-center">
                                <i title="Total amount outstanding" className="fa fa-info-circle text-secondary mr-2"></i>
                                <span style={{ fontSize: "14px", fontWeight: 500 }}>
                                    {item.label}
                                </span>
                            </div>

                            <strong
                                style={{
                                    fontSize: "16px",
                                    color: "#163B65",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <CurrencyLabel decimal={2} value={item.value} />
                            </strong>
                        </Link>
                    ))
                )}
            </div>
        </div>
    );
}

export default DueMonth;